import React from 'react';
import { useLocation } from 'react-router-dom';
import Page from '../../layout/Page';
import Awards from '../expressPass/Awards';
import KioskItems from '../settings/KioskItems';
import MobileProducts from '../mobile/Products';
import FulfillableProducts from '../fulfillment/Products';
import PlateReadAwards from '../plateReads/PlateReadAwards';
import EGift from './EGift';
import RequireFeature, {Features} from '../../RequireFeature';
import { findMenuLabelByPath } from '../../../constants/InitialMenu';

const Index = ({ ...props }) => {
    const location = useLocation();
    const title = findMenuLabelByPath(location.pathname + (location.hash || '#KioskItems')) || 'Products';

    return (
        <Page
            title={title}
            icon='coins'
            tabs
        >
            <KioskItems tab='Kiosk Items' soloTab />
            <Awards tab='ExpressPass' soloTab />
            <MobileProducts tab='Mobile' soloTab/>
            <FulfillableProducts tab='Fulfillment' soloTab />
            <PlateReadAwards tab='Plate Read Awards' requiredFeatures={Features.PlateReads} soloTab/>
            <EGift tab='App Credit' requiredFeatures={Features.AppCredit} soloTab/>
        </Page>
    );
}

export default Index;